module.exports = __webpack_public_path__ + "img/0Q3A4704_L_Black_MockedUp.91ce9e43.jpg";